import type { AboutCareersContent } from '../types/AboutCareersContent';
import { createContentHook } from './createContentHook';

export const useAboutCareersContent = createContentHook<AboutCareersContent>('/About/Careers');
